// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1I5lH","selected":"Chip_selected__396tG"};